module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1b_Image8e.6ed61f69.jpg";